export default __webpack_public_path__ + "static/media/Arrow_back.de20aa6d.png";